import React from 'react';
import { useTranslation } from 'react-i18next';
import CurvedArrowUp from '../icons/CurvedArrowUp';

const EmptyStateAll = () => {
  const { t } = useTranslation('components');

  return (
    <div className="p-3 bg-blue-400 text-white space-x-2 text-sm font-semibold flex items-center">
      <div className="p-1 -mb-1">
        <CurvedArrowUp className="m-2" />
      </div>
      <div>{t('AddressBook.EmptyStateAll')}</div>
    </div>
  );
};

export default EmptyStateAll;
